import React, { useEffect } from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'
import './MpProfileCard.css' // Custom styles if needed
import mpprofilecard from '../../../asserts/images/mpprofilecard.png'
import EditIcon from '@mui/icons-material/Edit'
import getUserProfile from 'store/action/getUserProfile'
import { useDispatch, useSelector } from 'react-redux'
import profileicon from '../../../asserts/images/profile.png'

const MpProfileCard = () => {
  const dispatch = useDispatch()

  const userProfile = useSelector((state) => state?.userProfile?.data)

  useEffect(() => {
    dispatch(getUserProfile())
  }, [])
  return (
    <Card className="custom-card">
      <CardContent className="content">
        <Box className="left-side">
          <Typography className="mpname">{userProfile?.user_name}</Typography>
          <Typography className="mpdetail">
            {userProfile?.designation ? userProfile?.designation : ''}{' '}
            {userProfile?.designation && userProfile?.house?.length > 0 ? '-' : ''}
            {userProfile?.house == 'RS'
              ? 'Rajya Sabha'
              : userProfile?.house == 'LS'
              ? ' Lok Sabha'
              : userProfile?.house}
          </Typography>

          {userProfile?.house === 'RS' ? (
            <Typography className="mpdetail">{userProfile?.state_name ? userProfile?.state_name : ''}</Typography>
          ) : (
            <>
              <div>
                <Typography className="mpdetail">
                  {userProfile?.constituency_name ? userProfile?.constituency_name : ''}
                </Typography>
                <Typography className="mpdetail">{userProfile?.state_name ? userProfile?.state_name : ''}</Typography>
              </div>
            </>
          )}
        </Box>
        <Box className="right-side">
          <Box className="right-side-inner">
            <img alt="Background" src={mpprofilecard} className="background-image" />
            <Box className="image-container">
              {userProfile?.user_avatar ? (
                <img src={userProfile?.user_avatar} className="image" />
              ) : (
                <img src={profileicon} className="image" />
              )}
              {/* <button className="edit-button">
                <EditIcon />
              </button> */}
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default MpProfileCard
